// extracted by mini-css-extract-plugin
export default {"unsubscription":"upmGoHt","heading":"VNTKcoZ","button":"TrCdOU3"};